import css from 'styled-jsx/css';
import Theme, { colors } from '../../../themes';

const { borderRadius } = Theme.global;
const { borderColor } = Theme.forms.inputs;

export default css`
  .select {
    display: inline-block;
    position: relative;
    width: 100%;
  }

  select {
    appearance: none;
    border: 1px solid ${borderColor};
    border-radius: ${borderRadius};
    padding: 1em;
    width: 100%;
  }

  .disabled {
    opacity: 0.5;
  }

  .isActive select {
    border-color: ${colors.blueLight};
    color: ${colors.blueLight};
  }

  .small select {
    font-size: 0.8125em; /* 13/16 */
    padding: 0.65em;
  }

  .medium select {
    font-size: 0.9375em; /* 15/16 */
    padding: 0.75em;
  }

  .big select {
    font-size: 1em; /* 16/16 */
    padding: 1em;
  }

  .arrow {
    position: absolute;
    pointer-events: none;
  }

  .isActive .arrow {
    position: absolute;
    color: ${colors.blue};
  }

  .small .arrow {
    right: 0.55em;
    top: 0.35em;
  }

  .medium .arrow {
    right: 0.75em;
    top: 0.65em;
  }

  .big .arrow {
    right: 0.85em;
    top: 0.75em;
  }

  :global(.rtl) .small .arrow {
    left: 0.55em;
    right: auto;
  }

  :global(.rtl) .medium .arrow {
    left: 0.75em;
    right: auto;
  }

  :global(.rtl) .big .arrow {
    left: 0.85em;
    right: auto;
  }
`;



// WEBPACK FOOTER //
// ./app/common/forms/Select/styles.js